import React from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { NewMessagesIndicatorContainer } from './styled';
import { useSelector } from 'react-redux';

const NewMessagesIndicator = ({ unreadCount, onClick }) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  return (
    <NewMessagesIndicatorContainer
      onClick={onClick}
      color={systemConfiguration.primary_color}
    >
      <FaChevronDown size={20} color="#525f7f" />
      {unreadCount > 0 && unreadCount < 100 && (
        <span>{unreadCount < 100 ? unreadCount : '99+'}</span>
      )}
    </NewMessagesIndicatorContainer>
  );
};

export default NewMessagesIndicator;
